module.exports = new __parcel__URL__("Charlie_Display-Thin_Italic.fa092ec4.woff").toString();